import styled from '@emotion/styled';
import { BaseTabPanel, Button, TabPanelContainer } from '@ui-components/neo.tax';

export const StyledButton = styled(Button)({
  margin: 0,
  justifyContent: 'space-between',
});

export const StyledTabPanelContainer = styled(TabPanelContainer)({
  height: '100%',
});

export const DeleteButton = styled(StyledButton)({
  width: 'fit-content',
});

export const StyledBaseTabPanel = styled(BaseTabPanel)({
  height: '100%',
});
